import {
    Component,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { MapTabWidgetComponent } from "@components/map/components/widgets/map-tab-widget/map-tab-widget.component";
import { MapWidgetTabComponent } from "@components/map/components/widgets/map-tab-widget/map-widget-tab/map-widget-tab.component";
import { TranslatePipe } from "@ngx-translate/core";
import { MapTabEvents } from "~app/common/components/map/components/widgets/map-tab-widget/events/map-tab-events";
import { MapTabEventService } from "~app/common/components/map/components/widgets/map-tab-widget/services/MapTabEventService";
import { IBridgeEvent } from "~app/common/services/event-bridge.service";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { DsoCacheService } from "./dso-edit/dso-cache.service";
import { DsoEditComponent } from "./dso-edit/dso-edit.component";
import { DsoKartaComponent } from "./dso-karta/dso-karta.component";
import { DsoSearchComponent } from "./dso-search/dso-search.component";
import { DsoEvents } from "./models/dso-events";
import { DsoEventService } from "./services/dso-event.service";

@Component({
    selector: "rask-destineringsomraden",
    templateUrl: "./destineringsomraden.component.html",
    styleUrls: ["./destineringsomraden.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MapTabWidgetComponent,
        MapWidgetTabComponent,
        DsoSearchComponent,
        DsoEditComponent,
        DsoKartaComponent,
        TranslatePipe
    ]
})
export class DestineringsomradenComponent implements OnInit, OnDestroy {
    currentTab = "";
    selectedEvent: IBridgeEvent;

    private readonly dsoCacheService = inject(DsoCacheService);
    private readonly eventService = inject(DsoEventService);
    private readonly mapTabEventService = inject(MapTabEventService);

    ngOnDestroy(): void {
        this.eventService.unsubscribe(this.selectedEvent);
        this.selectedEvent = null;
    }

    ngOnInit(): void {
        this.dsoCacheService.init();
        this.selectedEvent = this.eventService.subscribe(DsoEvents.dsoSelected, (payload) => {
            if (!ObjectUtils.isNullOrUndefined(payload)) {
                this.openEditTab();
            }
        });
        this.mapTabEventService.subscribe(MapTabEvents.TabChanged, (payload) => {
            this.currentTab = `tab-${payload}`;
        });
    }

    openEditTab() {
        if (this.currentTab !== "tab-edit") {
            this.currentTab = "tab-edit";
            const element: HTMLElement = document.getElementById(this.currentTab);
            element.click();
        }
    }
}
